import { useQuery } from "@apollo/client";

import { gql } from "~/__generated__";

export const USER_GET_BY_ID = gql(`
query UserGetById($userGetByIdId: ID!) {
  userGetById(id: $userGetByIdId) {
    id
    firstName
    lastName
    phone
    email
    profilePictureId
    externalReference
    fieldworker {
      id
      userId
      isMyWheelsUser
      isPayable
      hasFinishedOnboarding
      hasOwnTransport
      address
      isActive
      hasConfirmedAvailability
      maxShiftsPerWeek
      preferredTransportationMethod
    }
    tenantRole {
      id
      name
      permissions
    }
    userCourses {
      id
      name
      description
    }
    profilePictureMedia {
      id
      name
      mimeType
      isUploaded
      url
    }
  }
}
`);

export default function useUserGetById(userId: string) {
    const { data, loading, error } = useQuery(USER_GET_BY_ID, {
        variables: { userGetByIdId: userId },
    });
    return {
        loading,
        error,
        data: data?.userGetById,
    };
}
